// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__17Og_","buttons":"SendReceipts_buttons__xZF2-","email":"SendReceipts_email__2PWs3","bookApptTitle":"SendReceipts_bookApptTitle__XPkZG"};